import EchoLibrary from 'laravel-echo'

import is from '../web/plugins/helper/is'
import store from '~/store'

/**
 * @return {EchoLibrary|null}
 */
export const connect = () => {
  const appUrl = is.getValueSetting('echoServerHost')
  const port = is.getValueSetting('echoServerPort')
  if (is.checkVariable(appUrl) && is.checkVariable(port)) {
    const token = (is.checkVariable(store.getters) && store.getters.authToken) ? store.getters.authToken : ''

    return new EchoLibrary({
      broadcaster: 'socket.io',
      host: `${appUrl}:${port}`,
      // namespace: 'App',
      auth: {
        headers: {
          Authorization: 'Bearer ' + token,
        },
      },
    })
  }

  return null
}
